import { request } from '@aqx-core/common/request';

import {
  IBulkCloseMarketOrderParams,
  IBulkCloseMarketOrderResponse,
  IBulkClosePendingOrderParams,
  IBulkClosePendingOrderResponse,
  ICloseMarketOrderParams,
  IClosePendingOrderParams,
  ICreateMarketOrderParams,
  ICreatePendingOrderParams,
  IUpdateMarketOrderParams,
  IUpdatePendingOrderParams
} from '../model/types';

export default {
  closeMarketOrder: (params: ICloseMarketOrderParams) => request.put<boolean>('/api/trade/trade/v1', params),
  closePendingOrder: (params: IClosePendingOrderParams) =>
    request.delete<boolean>('/api/trade/trade/v1', {
      params
    }),
  bulkCloseMarketOrder: (params: IBulkCloseMarketOrderParams) =>
    request.put<IBulkCloseMarketOrderResponse>('/api/trade/trade/v1/bulk', params),
  createPendingOrder: (params: ICreatePendingOrderParams) => request.post<boolean>('/api/trade/trade/v1/limit', params),
  updatePendingOrder: (params: IUpdatePendingOrderParams) =>
    request.patch<boolean>('/api/trade/trade/v1/limit', params),
  bulkDeletePendingOrder: (params: IBulkClosePendingOrderParams[]) =>
    request.put<IBulkClosePendingOrderResponse>('/api/trade/trade/v1/limit/bulk', params),
  createMarketOrder: (params: ICreateMarketOrderParams) => request.post<boolean>('/api/trade/trade/v1/market', params),
  updateMarketOrder: (params: IUpdateMarketOrderParams) => request.patch<boolean>('/api/trade/trade/v1/market', params)
};
